<template>
  <v-dialog v-model="dialog" persistent max-width="425px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="pink" x-small v-bind="attrs" v-on="on" dark fab>
        <v-icon small="small">mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card grid-list-md>
      <ModelTitle title="Add Card" @close="cancel()" />
      <v-container grid-list-lg class="pt-0">
        <v-select dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object
          item-text="name" label="Select Default Account"></v-select>

        <CreditCard @submit="paymentCollected" :customer="customer" @cancel="cancel" v-if="selectedMerchant"
          :donationCategoryId="selectedMerchant.id" />

        <v-card-actions>
          <v-btn @click="submit" :loading="loading" color="primary" width="150" block large>Submit</v-btn>
        </v-card-actions>
      </v-container>

    </v-card>
  </v-dialog>
</template>
<!-- <script src="https://js.stripe.com/v3/"></script> -->
<!-- <script src="../../../../plugins/card.js" onload="fileLoaded()"></script> -->
<script>


// import customerService from "@/modules/Customer/service.js";
import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'
import donationCategoryService from "@/modules/DonationCategory/service.js";
import { mapGetters } from 'vuex';

export default {
  name: "customer-payment-method-collection",
  props: ['customer'],
  data() {
    return {
      selectedMerchant: null,
      MerchantAccount: [],
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus", 'currentBusiness']),
  },
  components: {
    CreditCard,
  },
  watch: {
    dialog(val) {
      if (val) {
        this.getDonationCategoryList()
      }
    }
  },
  methods: {
    getDonationCategoryList() {
      return donationCategoryService.getAll().then((response) => {
        // this.loading = false;
        console.log('response merchant', response)
        this.MerchantAccount = response.data;
        this.MerchantAccount.map(row => {
          if (row.id === this.currentBusiness.DefaultSchoolFeeId) {
            console.log('row', row)
            this.selectedMerchant = row
          }
        })
        // this.selectedMerchant = this.MerchantAccount[0]
        // this.itemsPerPage = this.merchants.length
      });
    },
    cancel() {
      this.$events.emit("closeCreditCard");
      this.dialog = false
    },
    submit() {
      this.$events.emit("submitCreditCard");
    },
    paymentCollected() {
      this.$emit('submit')
      this.dialog = !this.dialog
    },
  },
};
</script>

<style scoped></style>